function decodeInput (text) {
  try {
    let decoded = decodeURIComponent(text?.trim() || '')
    if (decoded.includes('%')) decoded = decodeURIComponent(decoded)
    return decoded
  } catch (_error) {
    return text?.trim() || ''
  }
}

function toCoords (lat, lng) {
  const safeLat = Number(lat)
  const safeLng = Number(lng)
  if (!Number.isFinite(safeLat) || !Number.isFinite(safeLng)) return null
  if (safeLat < -90 || safeLat > 90 || safeLng < -180 || safeLng > 180) return null
  return { lat: safeLat, lng: safeLng }
}

export function parseGoogleMapsLink (text) {
  const input = decodeInput(text)
  if (!input) return null

  const pinMatch = input.match(/!3d(-?\d+\.?\d*)!4d(-?\d+\.?\d*)/i)
  if (pinMatch) return toCoords(pinMatch[1], pinMatch[2])

  const atMatch = input.match(/@(-?\d+\.?\d*),(-?\d+\.?\d*)/)
  if (atMatch) return toCoords(atMatch[1], atMatch[2])

  for (const key of ['q', 'll', 'center', 'destination']) {
    const match = input.match(new RegExp(`[?&#]${key}=(-?\\d+\\.?\\d*),(-?\\d+\\.?\\d*)`, 'i'))
    if (match) return toCoords(match[1], match[2])
  }

  const plainMatch = input.match(/(-?\d{1,3}\.\d{4,}),\s*(-?\d{1,3}\.\d{4,})/)
  if (plainMatch) return toCoords(plainMatch[1], plainMatch[2])

  return null
}

export function needsGoogleMapsLinkResolve (text) {
  const input = text?.trim()
  if (!input) return false
  if (parseGoogleMapsLink(input)) return false
  return /maps\.app\.goo\.gl|goo\.gl\/maps|google\.[^/]+\/maps|maps\.google\./i.test(input)
}

export function googleMapsEmbedUrl (lat, lng) {
  return `https://maps.google.com/maps?q=${lat.toFixed(7)},${lng.toFixed(7)}&hl=en&z=17&output=embed`
}

// Center the map on coordinates without a Google pin (for custom overlay pins).
export function googleMapsCenterEmbedUrl (lat, lng, zoom = 17) {
  return `https://maps.google.com/maps?ll=${lat.toFixed(7)},${lng.toFixed(7)}&z=${zoom}&hl=en&output=embed`
}

export function googleMapsOpenUrl (lat, lng) {
  return `https://www.google.com/maps/search/?api=1&query=${lat.toFixed(7)},${lng.toFixed(7)}`
}

export function googleMapsDirectionsUrl (lat, lng, { originLat, originLng } = {}) {
  let url = `https://www.google.com/maps/dir/?api=1&destination=${lat.toFixed(7)},${lng.toFixed(7)}&travelmode=driving`
  if (originLat != null && originLng != null) {
    url += `&origin=${Number(originLat).toFixed(7)},${Number(originLng).toFixed(7)}`
  }
  return url
}
